import React from 'react'
import Svg from './Svg'
export const SvgChatBubble = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M12 2.1c-6.6 0-12 4.2-12 9.4 0 2.2.9 4.1 2.5 5.7l-.6 5.6 5.5-2.6c1.4.5 3 .7 4.6.7 6.6 0 12-4.2 12-9.4s-5.4-9.4-12-9.4z" />
  </Svg>
))
SvgChatBubble.isIcon = true
export default SvgChatBubble
